import * as React from "react"
import { Symbols } from "@tenforce/toolbox-fontmap"

interface Props {
    style: React.CSSProperties
}

export const PlaceholderConfigWidget = ({ style }: Props): JSX.Element => (
    <div
        className="theme-thumb is-dimmed tw-h-full tw-w-full tw-absolute tw-mx-2 bg-cloud"
        style={style}
    >
        <h3 className="tw-mr-2 is-invisible">{Symbols.PlaceholderTiny}</h3>
        <div className="tw-flex-1 is-invisible">
            <div className="label is-dimmed">{Symbols.PlaceholderSmall}</div>
            <div className="p">{Symbols.PlaceholderBig}</div>
        </div>
    </div>
)

export default PlaceholderConfigWidget
